// Chakra imports
import { Alert, AlertIcon, Box, Flex, Icon, Text } from '@chakra-ui/react';
import React from 'react';

function DefaultLayout(props) {
  const { children } = props;
  // Chakra color mode
  return (
    <Flex position="relative" h="max-content">
      <Flex
        h={{
          sm: 'initial',
          md: 'unset',
          lg: '100vh',
          xl: '97vh',
        }}
        w="100%"
        maxW={{ md: '66%', lg: '1313px' }}
        mx="auto"
        pt={{ sm: '50px', md: '0px' }}
        px={{ lg: '30px', xl: '0px' }}
        ps={{ xl: '70px' }}
        justifyContent="start"
        alignItems="center"
        direction="column"
      >
        {children}
        {/* <Footer /> */}
      </Flex>
    </Flex>
  );
}

export default DefaultLayout;
